var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 822.94 571.83002",
    width: 822.94,
    height: 571.83002,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#040506;}"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_207",
    "data-name": "Grupo 207",
    transform: "translate(-263.73,-250.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_322",
    "data-name": "Trazado 322",
    className: "cls-1",
    d: "m 1086.67,250.27 -0.83,74.63 -146.7,78.75 a 35.92,35.92 0 0 1 -29.65,-0.39 127.94,127.94 0 0 1 -27.49,-54.32 152.73,152.73 0 0 1 23.85,-7.12 l 36.84,-17.3 140.88,-74.35 z",
    style: {
      fill: "#040506"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_323",
    "data-name": "Trazado 323",
    className: "cls-1",
    d: "M 1086.26,453 932.7,543.7 c 0,0 48.84,110.85 71.91,163.7 l -102.9,-0.21 a 30.84,30.84 0 0 1 -27.22,-19.5 C 862,657 848.39,627 836.88,596.32 v 0 C 712,656.72 585.15,719.87 434.2,709.32 A 176.86,176.86 0 0 1 285.46,616.68 163.84,163.84 0 0 1 292.29,444.24 399.26,399.26 0 0 1 514.76,292.36 c 29.34,-6.41 75.33,-19.27 95,13.84 a 350.48,350.48 0 0 1 18.29,62.09 330.77,330.77 0 0 0 -191.63,64 285.08,285.08 0 0 0 -108.61,125.54 47.55,47.55 0 0 0 8.46,46 C 381.17,639.7 449,630.29 504.88,625 A 980.92,980.92 0 0 0 805.4,514.73 c 0,0 -33.3,-86.92 -49.9,-128.49 h -1.69 c -27.36,52.1 -49,106.55 -76.33,158.65 -33.79,31.61 -80.2,36.22 -123.45,45.76 l -10.92,1.35 0.39,-5.17 153.58,-288 4.12,-6.47 115.8,-0.44 a 217.21,217.21 0 0 1 16,33.79 l 64.1,139.69 187.27,-103.19 h 2 z",
    style: {
      fill: "#040506"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_324",
    "data-name": "Trazado 324",
    className: "cls-1",
    d: "m 1031.21,753.94 c 0,17.43 -0.13,68.06 -0.13,68.06 H 263.73 c 0.13,-20.54 0,-68.06 0,-68.06 z",
    style: {
      fill: "#040506"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaf);
export default __webpack_public_path__ + "static/media/caf.075c339d2366049fd9883d6f2e7fecf4.svg";
export { ForwardRef as ReactComponent };